import {action, computed, observable} from 'mobx';
import {endpoints, types} from 'shared/core';
import _ from 'lodash';
import {DomainObject, DomainStore} from 'shared/store';
import recruitingStore from 'stores/recruiting/RecruitingStore';
import Position from 'stores/recruiting/Position';
import Candidate from 'stores/recruiting/Candidate';
import {redirect, calendarDate} from 'shared/tools';

class AiScreenerRequest extends DomainObject {
  @observable position;
  @observable prompt;
  @observable model;
  @observable totalCandidateCount;

  @action merge(other) {
    super.merge(other, {
      position: Position
    });
  }
}

class AiScreenerCandidateResult extends DomainObject {
  @observable explanation;
  @observable rating;
  @observable candidate;

  @action merge(other) {
    super.merge(other, {
      candidate: Candidate
    });
  }
}

class AiScreenerContainerState {
  store = new DomainStore();
  requestId;
  positions = [];

  @observable candidateResults = [];
  @observable request = new AiScreenerRequest({model: 'gpt-4.1-nano'});

  receiveProps({match, history}) {
    this.requestId = match.params.requestId;
    this.history = history;
  }

  @action async load() {
    await recruitingStore.loadAll();
    this.positions = recruitingStore.getAll();

    if (this.requestId) {
      await this.store._compose([
        endpoints.AI_SCREENER.REQUESTS.with(this.requestId)
      ]);
      this.request = new AiScreenerRequest(this.store._getSingle(types.AI_SCREENER_REQUEST));

      await this.loadCandidates();
    }
  }

  @action async loadCandidates() {
    await this.store._compose([
      endpoints.AI_SCREENER.CANDIDATES.with(this.requestId)
    ]);

    this.candidateResults = this.store._getAll(types.AI_SCREENER_CANDIDATE, AiScreenerCandidateResult);
  }

  @action async submitRequest() {
    const {model} = await this.store.post(
      endpoints.AI_SCREENER.REQUESTS.ALL,
      types.AI_SCREENER_REQUEST,
      this.request
    );

    return redirect(`/recruiting/ai/${model.id}`);
  }

  @computed get sortedCandidateResults() {
    return _.orderBy(this.candidateResults, 'rating', 'desc');
  }

  @computed get labelledPositions() {
    return _.map(this.positions, position => {
      return {
        id: position.id,
        title: `(${position.id}) ${position.title} from ${calendarDate(position.createdAt)}`
      };
    });
  }
}

export default AiScreenerContainerState;
